module.exports = __webpack_public_path__ + "img/14.a4977646.png";